import { render, staticRenderFns } from "./MenuPermissionsTable.vue?vue&type=template&id=bf267ab2&"
import script from "./MenuPermissionsTable.vue?vue&type=script&lang=js&"
export * from "./MenuPermissionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports